export interface PressMention {
  outlet: string;
  logoUrl: string;
  articleUrl: string;
  headline: string;
  publishedAt: string; // ISO date
}

// TODO(content): populate once ZenFresh has real press coverage to link to.
// Deliberately empty — inventing publication names/logos here would be a
// specific, checkable false credibility claim, not a harmless placeholder.
// PressLogoStrip.tsx renders nothing while this is empty (see ZP-96 AC3);
// PressMentionsFeed.tsx (ZP-50) shows an honest "no coverage yet" state and
// omits its filter controls (nothing to filter with zero entries) instead.
// `headline`/`publishedAt` added for ZP-50 — same array, same honesty
// reasoning, just a richer shape once real coverage exists to populate it.
export const PRESS_MENTIONS: PressMention[] = [];
